import React, { useState } from 'react'
import { Navigate } from 'react-router'
import { Box, Container } from '@mui/material'
import { useIsUser } from 'pages/Identity/Login'
import KioskWelcomeStep from './kiosk/KioskWelcomeStep'
import KioskEmployerStep from './kiosk/KioskEmployerStep'
import KioskRecruiterStep from './kiosk/KioskRecruiterStep'
import KioskJobFormStep from './kiosk/KioskJobFormStep'
import KioskThankYouStep from './kiosk/KioskThankYouStep'

const initialWizardData = {
  employerId: null,
  employerName: '',
  employerUserId: null,
  firstName: '',
  lastName: '',
  email: '',
  matchCounts: null,
}

const KioskPage = () => {
  const { isSuper } = useIsUser()
  const [step, setStep] = useState(0)
  const [wizardData, setWizardData] = useState(initialWizardData)

  if (!isSuper) {
    return <Navigate to='/' replace />
  }

  const handleNext = () => setStep(prev => prev + 1)
  const handleBack = () => setStep(prev => prev - 1)

  const handleStartOver = () => {
    setStep(0)
    setWizardData(initialWizardData)
  }

  return (
    <Container maxWidth='md' sx={{ py: 4 }}>
      <Box>
        {step === 0 && <KioskWelcomeStep onNext={handleNext} />}
        {step === 1 && (
          <KioskEmployerStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 2 && (
          <KioskRecruiterStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 3 && (
          <KioskJobFormStep
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        )}
        {step === 4 && (
          <KioskThankYouStep
            wizardData={wizardData}
            onStartOver={handleStartOver}
          />
        )}
      </Box>
    </Container>
  )
}

export default KioskPage
